import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ImageZoomModal from './ImageZoomModal';
import './ImageGallery.css';

function ImageGallery({ images }) {
  const { t } = useTranslation();
  const list = Array.isArray(images) && images.length > 0 ? images : [];
  const [activeIndex, setActiveIndex] = useState(0);
  const [isZoomModalOpen, setIsZoomModalOpen] = useState(false);
  const displayList = list.length ? list : [];

  // Предотвращаем скролл страницы при открытом модальном окне
  useEffect(() => {
    if (isZoomModalOpen) {
      document.body.classList.add('imageZoomModalOpen');
    } else {
      document.body.classList.remove('imageZoomModalOpen');
    }
    return () => {
      document.body.classList.remove('imageZoomModalOpen');
    };
  }, [isZoomModalOpen]);

  if (displayList.length === 0) return null;

  const goPrev = () => {
    setActiveIndex((i) => (i === 0 ? displayList.length - 1 : i - 1));
  };
  const goNext = () => {
    setActiveIndex((i) => (i === displayList.length - 1 ? 0 : i + 1));
  };

  const handleImageClick = () => {
    setIsZoomModalOpen(true);
  };

  return (
    <>
      <div className="imageGallery">
        <div className="imageGalleryMain">
          {displayList.length > 1 && (
            <button
              type="button"
              className="imageGalleryArrow imageGalleryArrowLeft"
              onClick={goPrev}
              aria-label={t('common.previous')}
            >
              ‹
            </button>
          )}
          <button
            type="button"
            className="imageGalleryMainImage"
            onClick={handleImageClick}
            aria-label={t('common.zoom')}
          >
            <img src={displayList[activeIndex]} alt="" />
          </button>
          {displayList.length > 1 && (
            <button
              type="button"
              className="imageGalleryArrow imageGalleryArrowRight"
              onClick={goNext}
              aria-label={t('common.next')}
            >
              ›
            </button>
          )}
        </div>
        {displayList.length > 1 && (
          <div className="imageGalleryThumbs">
            {displayList.map((src, i) => (
              <button
                type="button"
                key={i}
                className={`imageGalleryThumb ${i === activeIndex ? 'active' : ''}`}
                onClick={() => setActiveIndex(i)}
              >
                <img src={src} alt="" />
              </button>
            ))}
          </div>
        )}
      </div>

      {isZoomModalOpen && (
        <ImageZoomModal
          images={displayList}
          initialIndex={activeIndex}
          onClose={() => setIsZoomModalOpen(false)}
        />
      )}
    </>
  );
}

export default ImageGallery;
